import MediaLibraryCollectionStorage from './storage-collection';
import MediaLibraryEvents from './events';

class MediaLibraryCollectionCounter
{
    constructor()
    {
        // Imports
        this.mediaLibraryCollectionStorage = new MediaLibraryCollectionStorage();

        // Elements
        this.counterElements = document.querySelectorAll('.js-media-library__collection-counter');
    }

    init()
    {
        this.initCollectionCounter();
        this.initEvents();
    }

    initEvents()
    {
        document.addEventListener('add-to-collection', () =>
        {
            this.initCollectionCounter();
        });

        document.addEventListener('remove-from-collection', () =>
        {
            this.initCollectionCounter();
        });

        document.addEventListener(MediaLibraryEvents.validateCollection, () =>
        {
            this.initCollectionCounter();
        });
    }

    initCollectionCounter()
    {
        let collection = this.getCollection();
        let counterValue = collection ? collection.length : 0;

        this.counterElements.forEach(counterElement =>
        {
            if (counterValue !== 0)
            {
                counterElement.classList.remove('hidden');
                counterElement.innerText = counterValue;
            }
            else
            {
                counterElement.classList.add('hidden');
            }
        });
    }

    /**
	 * @return {Array} asset ids in collection
	 */
    getCollection()
    {
        let customerId = orion.getCustomerId();

        if (this.mediaLibraryCollectionStorage.hasCollection(customerId))
        {
            this.mediaLibraryCollectionStorage.restoreCollection(customerId);
            return this.mediaLibraryCollectionStorage.getCollection();
        }
    }
}

if (document.querySelector('body').classList.contains('authorized'))
{
    let mediaLibraryCollectionCounter = new MediaLibraryCollectionCounter();

    mediaLibraryCollectionCounter.init();
}
